//new WOW().init();
//$(window).on('resize',function(){location.reload();});

/*$( ".zoomContainer" ).each(function() {
  console.log( index + ": " + $( this ).text() );
});*/

$(document).ready(function (e) {
   
    
    $("#sortby ul li:not(:first-of-type)").click(function (){
       $("#sortby ul li").removeClass("active");
       $(this).addClass("active");
   });  
    $(".owl-example5").owlCarousel({
 
    // Most important owl features
    items : 1,
    singleItem : true,
    pagination:false,
    navigation:true,
//     autoPlay:2000,
    navigationText:["",""],
});
    $("#owl-example").owlCarousel({
 
    // Most important owl features
    items : 5,
    itemsCustom : false,
    itemsDesktopSmall : [980,3],
    itemsTablet: [768,3],
    itemsTabletSmall: false,
    itemsMobile : [600,1],
    singleItem : false,
    itemsScaleUp : false,
    pagination:false,
    navigation:true,
    navigationText:["",""],
});
     $(".owl-example2").owlCarousel({
 
    // Most important owl features
    items : 3,
    itemsCustom : false,
    itemsDesktopSmall : [1900,3],
    itemsTablet: [768,2],
    itemsTabletSmall: false,
    itemsMobile : [600,1],
    singleItem : false,
    itemsScaleUp : false,
    pagination:false,
    navigation:true,
    navigationText:["",""],
         slideSpeed: 1200,
});
    
     $("#owl-example-main").owlCarousel({
 
    // Most important owl features
    items : 1,
    singleItem : true,
    pagination:false,
    navigation:true,
     autoPlay:5000,
    navigationText:["",""],
});
    /* $(function() {
				$('#dg-container').gallery();
			});*/
    var ahyt =$(".component-fullwidth nav a").height();
    $(".component-fullwidth nav a").css("margin-top", - ahyt/2);
    /***/
    var chyt = $("#component ul li img").height();
    $("#component").css("height",chyt);
     /**lang-toggle*****/
    $(".lng p img").click(function () {
        $(".lng p:nth-of-type(2)").slideToggle();
    });
     /***menu-toggle*****/
    $(".menu-icon").click(function () {
        $(".menu").slideToggle();
    });
    /***offers section hyt*****/
 
    if ($(window).width() >= 768) {
      
      
      $(".menu .nav li").click(function(){
          
          var get_class = $(this).attr('class');
          
          $(".mega-menu-section").each(function() {
            
             if ($(this).children().attr('id') == get_class) {
               
               var not_class = ".sub-menu#"+ get_class;
           		$(".sub-menu:not('"+not_class+"')").slideUp();
        		$(".sub-menu#"+get_class).slideToggle( "slow" );
             }
            
          });
          
      });
      
        
        /* var offhyt = $("#offer > img").height();
         $("#offer").css("height",offhyt);
        var hyt = $("#offer .offer-txt").height();
        $("#offer .offer-txt").css("margin-top", -(hyt / 2));*/
         var hyt2 = $("#subscribe .inner a").outerHeight();
             $("#subscribe .inner input").css("height",hyt2);
        $(window).on('resize', function () {
            /*var hyt = $("#offer .offer-txt").height();
            $("#offer .offer-txt").css("margin-top", -(hyt / 2));*/
            /*************/
             var hyt2 = $("#subscribe .inner a").outerHeight();
             $("#subscribe .inner input").css("height",hyt2);
        });
    };
    if ($(window).width() <= 768) {
         $(".menu .nav li.textile > a").click(function(){
         $(".sub-menu-mob:not(.sub-menu-mob#textile)").slideUp();
         $(".sub-menu-mob#textile").slideToggle();
    });
        $(".menu .nav li.access > a").click(function(){
         $(".sub-menu-mob:not(.sub-menu-mob#access)").slideUp();
         $(".sub-menu-mob#access").slideToggle();
    });
        $(".menu .nav li.cosmet > a").click(function(){
         $(".sub-menu-mob:not(.sub-menu-mob#cosmet)").slideUp();
         $(".sub-menu-mob#cosmet").slideToggle();
    });
        /****************inner-sub-menu-types******************/
     $(".menu .nav li.textile .sub-menu-mob#textile li.types a ").click(function(){
//         $(".brands ul").slideUp();
         $(".menu .nav li.textile .sub-menu-mob#textile li.brands ul").slideUp();
         $(this).parent("li").find("ul").slideToggle();
    });
        $(".menu .nav li.cosmet .sub-menu-mob#cosmet li.types a ").click(function(){
        //         $(".brands ul").slideUp();
         $(".menu .nav li.cosmet .sub-menu-mob#cosmet li.brands ul").slideUp();
         $(this).parent("li").find("ul").slideToggle();
    });
        $(".menu .nav li.access .sub-menu-mob#access li.types a ").click(function(){
         //         $(".brands ul").slideUp();
        $(".menu .nav li.access .sub-menu-mob#access li.brands ul").slideUp();
         $(this).parent("li").find("ul").slideToggle();
    });
        /*******inner-sub-menu-brands*********/
        $(".menu .nav li.textile .sub-menu-mob#textile li.brands a ").click(function(){
//         $(".brands ul").slideUp();
         $(".menu .nav li.textile .sub-menu-mob#textile li.types ul").slideUp();
         $(this).parent("li").find("ul").slideToggle();
    });
        $(".menu .nav li.cosmet .sub-menu-mob#cosmet li.brands a ").click(function(){
        //         $(".brands ul").slideUp();
        $(".menu .nav li.cosmet .sub-menu-mob#cosmet li.types ul").slideUp();
         $(this).parent("li").find("ul").slideToggle();
    });
        $(".menu .nav li.access .sub-menu-mob#access li.brands a ").click(function(){
         //         $(".brands ul").slideUp();
         $(".menu .nav li.access .sub-menu-mob#access li.types ul").slideUp();
         $(this).parent("li").find("ul").slideToggle();
    });
        var chyt1 = $("#component ul li img").height();
        $("#component ul li .main").css("top",chyt1);
         var chyt2 = $("#component ul li .main").outerHeight();
         var chyt3 = chyt1 + chyt2;
        $("#component").css("height",chyt3);
     $(window).on('resize', function () {
          var chyt1 = $("#component ul li img").height();
        $("#component ul li .main").css("top",chyt1);
         var chyt2 = $("#component ul li .main").outerHeight();
         var chyt3 = chyt1 + chyt2;
        $("#component").css("height",chyt3);
        
     });}
});

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

jQuery(document).ready(function(){
jQuery('#SortByproducts li').click(function(){
 var sorting = jQuery(this).attr('data_value');
 if(sorting && sorting != "" && sorting != null){
  var updatedurl = updateQueryStringParameter(document.URL,'sort_by',sorting);
  window.location = updatedurl;
 }
});
});

